import Api from "../../../config/api";
import {
  CREATE_CREDENTIAL,
  SEARCH_CREDENTIAL,
  SEARCH_CREDENTIAL_BY_ID,
  UPDATE_CREDENTIAL,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getCredential = async (params: any) => {
  try {
    const res = await Api(false).get(SEARCH_CREDENTIAL, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getCredentialById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_CREDENTIAL_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createCredential = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_CREDENTIAL, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateCredential = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_CREDENTIAL}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
